import React from 'react'
import ReactDOM from 'react-dom/client'
import CapyChat from './components/CapyChat'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<CapyChat />)
